import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单管理', icon: 'oms'},
    alwaysShow: true,
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'oms-order'}
      }
    ]
  },
  {
    path:'/meal',
    component: Layout,
    redirect: '/meal/classes',
    name: 'meal',
    alwaysShow: true,
    meta: {title: '餐品管理', icon: 'meal'},
    children: [
      {
        path: 'classes',
        name: 'classes',
        component: () => import('@/views/meal/classes/index'),
        meta: {title: '餐品分类列表', icon: 'meal-classes'}
      },
      {
        path: 'period',
        name: 'period',
        component: () => import('@/views/meal/period/index'),
        meta: {title: '餐段设置', icon: 'meal-period'}
      },
      {
        path: 'editPeriod',
        name: 'edit',
        component: () => import('@/views/meal/period/edit'),
        meta: {title: '餐段设置', icon: 'meal-period'},
        hidden:true
      },
      {
        path: 'editPeriodItem',
        name: 'itemEdit',
        component: () => import('@/views/meal/period/itemEdit'),
        meta: {title: '餐段明细设置', icon: 'meal-period'},
        hidden:true
      },
      {
        path: 'returnClassDetail',
        name: 'Detail',
        component: () => import('@/views/meal/classes/Detail'),
        meta: {title: '分类详情',icon: 'meal-classes'},
        hidden:true
      },
      {
        path: 'addClass',
        name: 'addClass',
        component: () => import('@/views/meal/classes/add'),
        meta: {title: '添加分类',icon: 'meal-classes'},
        hidden: true
      },
      {
        path: 'updateClass',
        name: 'updateClass',
        component: () => import('@/views/meal/classes/update'),
        meta: {title: '编辑分类',icon: 'meal-classes'},
        hidden: true},
      {
        path: 'menu',
        name: 'menues',
        component: () => import('@/views/meal/menu/index'),
        meta: {title: '餐品菜单管理', icon: 'meal-menu'}
      },
      {
        path: 'addMenus',
        name: 'addMenus',
        component: () => import('@/views/meal/menu/add'),
        meta: {title: '添加菜单',icon: 'meal-menu'},
        hidden: true
      },
      {
        path: 'menuDishEdit',
        name: 'menuDishEdit',
        component: () => import('@/views/meal/menu/dish/edit'),
        meta: {title: '编辑菜单',icon: 'meal-menu'},
        hidden: true
      },
      {
        path: 'dish',
        name: 'dish',
        component: () => import('@/views/meal/dish/index'),
        meta: {title: '餐品库', icon: 'meal-dish'}
      },
      {
        path: 'returnDishDetail',
        name: 'Detail',
        component: () => import('@/views/meal/dish/Detail'),
        meta: {title: '餐品详情',icon: 'meal-dish'},
        hidden:true
      },
      {
        path: 'updateDish',
        name: 'updateDish',
        component: () => import('@/views/meal/dish/update'),
        meta: {title: '编辑餐品',icon: 'meal-dish'},
        hidden: true
      }]
  },
  {
    path:'/eq',
    component: Layout,
    redirect: '/eq/cash',
    name: 'eq',
    meta: {title: '设备管理', icon: 'eq'},
    alwaysShow: true,
    children: [
      {
        path: 'cash',
        name: 'cash',
        component: () => import('@/views/eq/cash/index'),
        meta: {title: '收银机列表', icon: 'eq-cash'}
      },
      {
        path: 'returnCashDetail',
        name: 'Detail',
        component: () => import('@/views/eq/cash/Detail'),
        meta: {title: '收银机设备详情',icon: 'eq-cash'},
        hidden:true
      },
      {
        path: 'addCash',
        name: 'addCash',
        component: () => import('@/views/eq/cash/add'),
        meta: {title: '添加收银机',icon: 'eq-cash'},
        hidden: true
      },
      {
        path: 'updateCash',
        name: 'updateCash',
        component: () => import('@/views/eq/cash/update'),
        meta: {title: '编辑收银机',icon: 'eq-cash'},
        hidden: true
      },
      {
        path: 'printer',
        name: 'printer',
        component: () => import('@/views/eq/printer/index'),
        meta: {title: '打印机列表', icon: 'eq-printer'}
      },
      {
        path: 'returnPrinterDetail',
        name: 'Detail',
        component: () => import('@/views/eq/printer/Detail'),
        meta: {title: '打印机详情',icon: 'eq-printer'},
        hidden:true
      },
      {
        path: 'addPrinter',
        name: 'addPrinter',
        component: () => import('@/views/eq/printer/add'),
        meta: {title: '添加打印机',icon: 'eq-printer'},
        hidden: true
      },
      {
        path: 'updatePrinter',
        name: 'updatePrinter',
        component: () => import('@/views/eq/printer/update'),
        meta: {title: '编辑打印机',icon: 'eq-printer'},
        hidden: true
      },
      {
        path: 'printRecord',
        name: 'printRecord',
        component: () => import('@/views/eq/printRecord/index'),
        meta: {title: '打印记录管理', icon: 'eq-printerRecord'}
      },
      {
        path: 'printTemplate',
        name: 'printTemplate',
        component: () => import('@/views/eq/printTemplate/index'),
        meta: {title: '打印机模版列表', icon: 'eq-printTemplate'}
      },
      {
        path: 'addPrintTemplate',
        name: 'addPrintTemplate',
        component: () => import('@/views/eq/printTemplate/add'),
        meta: {title: '添加打印机模版',icon: 'eq-printTemplate'},
        hidden: true
      },
      {
        path: 'updatePrintTemplate',
        name: 'updatePrintTemplate',
        component: () => import('@/views/eq/printTemplate/update'),
        meta: {title: '编辑打印机模版',icon: 'eq-printTemplate'},
        hidden: true
      },
      {
        path: 'returnPrintTemplateDetail',
        name: 'Detail',
        component: () => import('@/views/eq/printTemplate/Detail'),
        meta: {title: '打印机模版详情',icon: 'eq-printTemplate'},
        hidden:true
      },
    ]
  },
  {
    path: '/store',
    component: Layout,
    redirect: '/store/brand',
    name: 'store',
    meta: {title: '门店管理', icon: 'store'},
    alwaysShow: true,
    children: [
      {
        path: 'brand',
        name: 'list',
        component: () => import('@/views/store/brand/index'),
        meta: {title: '门店列表',icon: 'store-list'}
      },
      {
        path: 'returnStoreDetail',
        name: 'Detail',
        component: () => import('@/views/store/brand/Detail'),
        meta: {title: '门店详情',icon: 'store'},
        hidden:true
      },
      {
        path: 'addStore',
        name: 'addStore',
        component: () => import('@/views/store/brand/add'),
        meta: {title: '添加门店',icon: 'store'},
        hidden: true
      },
      {
        path: 'updateStore',
        name: 'updateStore',
        component: () => import('@/views/store/brand/update'),
        meta: {title: '编辑门店',icon: 'store'},
        hidden: true
      },{
        path: 'paymentMethod',
        name: 'paymentMethod',
        component: () => import('@/views/store/paymentMethod/index'),
        meta: {title: '其他支付方式',icon: 'store-paymentMethod'},
        hidden: true
      },
      {
        path: 'paymentMethod/manage',
        name: 'paymentMethodManage',
        component: () => import('@/views/store/paymentMethod/manage'),
        meta: {title: '支付方式管理',icon: 'store-paymentMethod'},
        hidden: true
      }
    ]
  },
  {
    path:'/dt',
    component: Layout,
    redirect: '/dt/hours',
    name: 'dt',
    meta: {title: '营业报表', icon: 'dt'},
    alwaysShow: true,
    children: [
      {
        path: 'hours',
        name: 'hours',
        component: () => import('@/views/dt/hours/index'),
        meta: {title: '时段销量', icon: 'dt-hours'}
      },
      {
        path: 'ranking',
        name: 'ranking',
        component: () => import('@/views/dt/ranking/index'),
        meta: {title: '餐品销量排行', icon: 'dt-ranking'},
        hidden: true
      },
      {
        path: 'forms',
        name: 'forms',
        component: () => import('@/views/dt/forms/index'),
        meta: {title: '订单统计', icon: 'dt-forms'},
        hidden: true
      },
      {
        path: 'payway',
        name: 'payway',
        component: () => import('@/views/dt/payway/index'),
        meta: {title: '支付方式统计', icon: 'dt-forms'},
        hidden: true
      },
      {
        path: 'device',
        name: 'device',
        component: () => import('@/views/dt/device/index'),
        meta: {title: '设备订单统计', icon: 'dt-forms'},
        hidden: true
      },
      {
        path: 'mealCategory',
        name: 'mealCategory',
        component: () => import('@/views/dt/mealCategory/index'),
        meta: {title: '餐品分类占比', icon: 'dt-forms'},
        hidden: true
      },
       {
        path: 'refund',
        name: 'refund',
        component: () => import('@/views/dt/refund/index'),
        meta: {title: '退款订单统计', icon: 'dt-forms'},
        hidden: true
      },
      {
        path: 'monthSale',
        name: 'monthSale',
        component: () => import('@/views/dt/monthSale/index'),
        meta: {title: '4', icon: 'dt-forms'},
        hidden: true
      },

      {
        path: 'exception',
        name: 'exception',
        component: () => import('@/views/dt/exception/index'),
        meta: {title: '异常报告', icon: 'dt-forms'},
        hidden: false
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    alwaysShow: true,
    children: [
      {
        path: 'vps',
        name: 'vps',
        component: () => import('@/views/ums/vps/index'),
          meta: {title: 'APP版本列表',icon: 'ums-vps'}
      },
      {
        path: 'returnAppVersionDetail',
        name: 'Detail',
        component: () => import('@/views/ums/vps/Detail'),
        meta: {title: 'APP版本详情',icon: 'ums-vps'},
        hidden:true
      },
      {
        path: 'addAppVersion',
        name: 'addAppVersion',
        component: () => import('@/views/ums/vps/add'),
        meta: {title: '添加APP版本',icon: 'ums-vps'},
        hidden: true
      },
      {
        path: 'updateAppVersion',
        name: 'updateAppVersion',
        component: () => import('@/views/ums/vps/update'),
        meta: {title: '编辑APP版本',icon: 'ums-vps'},
        hidden: true
      },
      {
        path: 'handbook',
        name: 'handbook',
        component: () => import('@/views/ums/handbook/index'),
        meta: {title: '操作手册列表',icon: 'ums-handbook'}
      },
      {
        path: 'returnHandbookDetail',
        name: 'Detail',
        component: () => import('@/views/ums/handbook/Detail'),
        meta: {title: '操作手册详情',icon: 'ums-handbook'},
        hidden:true
      },
      {
        path: 'addHandbook',
        name: 'addHandbook',
        component: () => import('@/views/ums/handbook/add'),
        meta: {title: '添加操作手册版本',icon: 'ums-handbook'},
        hidden: true
      },
      {
        path: 'updateHandbook',
        name: 'updateHandbook',
        component: () => import('@/views/ums/handbook/update'),
        meta: {title: '编辑操作手册版本',icon: 'ums-handbook'},
        hidden: true
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'exceptionReportConfig',
        name: 'exceptionReportConfig',
        component: () => import('@/views/ums/exception/index'),
        meta: {title: '异常设置'},
        hidden: false
      },
      {
        path: 'thirdPartyApplications',
        name: 'thirdPartyApplications',
        component: () => import('@/views/ums/thirdPartyApplications/index'),
        meta: {title: '第三方应用', icon: 'third-partyApplications'},
        hidden: false
      },
      {
        path: 'thirdPartyApplications/manage',
        name: 'thirdPartyApplicationsManage',
        component: () => import('@/views/ums/thirdPartyApplications/manage'),
        meta: {title: '第三方应用管理'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js